// RT-19: Stable device fingerprint for multi-account fraud detection.
// Uses only non-PII browser characteristics hashed via SHA-256.
// The hash is opaque, no individual trait is stored or logged.

export async function getDeviceFingerprint(): Promise<string> {
  const components = [
    navigator.userAgent,
    navigator.language,
    screen.colorDepth.toString(),
    `${screen.width}x${screen.height}`,
    new Date().getTimezoneOffset().toString(),
    (navigator.hardwareConcurrency ?? '').toString(),
    (navigator.platform ?? ''),
    // Canvas fingerprint (lightweight, just font rendering differences)
    await canvasFingerprint(),
  ];

  const raw = components.join('|');
  const encoded = new TextEncoder().encode(raw);
  const hashBuffer = await crypto.subtle.digest('SHA-256', encoded);
  return Array.from(new Uint8Array(hashBuffer))
    .map(b => b.toString(16).padStart(2, '0'))
    .join('');
}

async function canvasFingerprint(): Promise<string> {
  try {
    const canvas = document.createElement('canvas');
    canvas.width = 200;
    canvas.height = 50;
    const ctx = canvas.getContext('2d');
    if (!ctx) return '';
    ctx.textBaseline = 'top';
    ctx.font = '14px Arial';
    ctx.fillStyle = '#f60';
    ctx.fillRect(125, 1, 62, 20);
    ctx.fillStyle = '#069';
    ctx.fillText('Profys', 2, 15);
    ctx.fillStyle = 'rgba(102,204,0,0.7)';
    ctx.fillText('Profys', 4, 17);
    return canvas.toDataURL().slice(-50); // last 50 chars of data URL, sufficient diff signal
  } catch {
    return '';
  }
}
